import { SelectOptionType } from '@/components/content/SelectBoxTypes'
import { useGetOutboundSchedules } from '@/services/outboundSchedule2/useOutboundScheduleQueries'
import { useGetCutOffWarehouses } from '@/services/warehouse/useWareHouseQueries'
import { useCutOffDate } from './useCutOffDate'

/**
 *  현재 선택한 시간에 isActive한 warehouse만 옵션으로 노출
 */
export const useAllocationWarehouseOptions = ({ time }: { time: string }): SelectOptionType<string>[] => {
  const { cutOffDate, shipperCode } = useCutOffDate()

  const { options } = useGetCutOffWarehouses()

  const { data: schedulesData } = useGetOutboundSchedules({ date: cutOffDate, shipperCode, cutType: 'B2C' })

  const isActiveWarehouseCodes =
    (schedulesData?.slots ?? [])
      .find((slot) => slot.startTime.slice(0, 5) === time)
      ?.warehouses.filter(({ isEnabled }) => isEnabled)
      .map(({ warehouseCode }) => warehouseCode) || []

  return options.filter(({ module }) => module === 'MWMS').filter(({ value }) => isActiveWarehouseCodes.includes(value))
}
